import { render, staticRenderFns } from "./address_list.vue?vue&type=template&id=44006dae&scoped=true"
import script from "./address_list.vue?vue&type=script&lang=js"
export * from "./address_list.vue?vue&type=script&lang=js"
import style0 from "./address_list.vue?vue&type=style&index=0&id=44006dae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44006dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44006dae')) {
      api.createRecord('44006dae', component.options)
    } else {
      api.reload('44006dae', component.options)
    }
    module.hot.accept("./address_list.vue?vue&type=template&id=44006dae&scoped=true", function () {
      api.rerender('44006dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_submission/form/components/address_list.vue"
export default component.exports